import { message } from 'antd';

function numberCheck(value, conditions) {
  if (typeof conditions === 'number') return value === conditions;
  if (conditions === null || conditions.max === null) return true;
  if (conditions.max != null && value > conditions.max) return false;
  if (conditions.min != null && value < conditions.min) return false;

  return true;
}

function typeCheck(value, conditions) {
  if (typeof conditions === 'string') return value === conditions;
  return conditions.indexOf(value) !== -1;
}

function getImageWH(file) {
  let resolve, reject;

  let promise = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });

  const filereader = new FileReader();
  filereader.onload = (e) => {
    const src = e.target.result;
    const image = new Image();
    image.onload = function () {
      resolve({ width: image.width, height: image.height });
    };
    image.onerror = reject;
    image.src = src;
  };
  filereader.readAsDataURL(file);
  return promise;
}

export function validate(data, conditions) {
  let errorItem = null;

  conditions.some((condition) => {
    const value = data[condition.type];
    if (value === undefined) {
      console.error('条件异常', condition);
      return;
    }

    switch (condition.type) {
      case 'width':
      case 'height':
      case 'size': {
        if (!numberCheck(value, condition.value)) {
          errorItem = condition;
          return true;
        }
        break;
      }
      case 'type': {
        if (!typeCheck(value, condition.value)) {
          errorItem = condition;
          return true;
        }
      }
    }
  });

  if (errorItem == null) return null;

  return new Error(errorItem.message);
}

/**
 * example: checkImage(file, [
 *  {type: 'width', value: {max: 100, min: 10}, message: ''},
 *  {type: 'height', value: {max: 100, min: 10}, message: ''},
 *  {type: 'type', value: ['image/jpeg', 'image/png'], message: '},
 *  {type: 'size', value: 100, message: ''}
 * ])
 */
export function checkImage(file, conditions) {
  const fileType = file.type;
  const fileSize = file.size / 1024; //

  let resolve, reject;
  const promise = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });

  getImageWH(file).then(({ height, width }) => {
    const result = validate({ height, width, type: fileType, size: fileSize }, conditions);
    if (result == null) resolve();
    else reject(result);
  });

  return promise;
}

export function beforeUpload(file, accept, width, height, max) {
  return checkImage(file, [
    accept && { type: 'type', value: accept, message: '不支持该格式图片！' },
    { type: 'size', value: { max: max }, message: '图片大小不符合规范！' },
    { type: 'width', value: width, message: '图片宽不符合规范！' },
    { type: 'height', value: height, message: '图片高不符合规范！' },
  ]).catch((ex) => {
    console.error(ex);
    message.error(ex.message);
    throw ex;
  });
}
